export default "__VITE_ASSET__YAKZIQpHVaCflWXpetaHNw__"